import { LitElement, html, css } from 'lit'
import { nanoid } from 'nanoid'
export class AccordionItem extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    .body {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.35s linear;
    }

    slot[name='header'] {
      cursor: pointer;
    }
  `

  static properties = {
    open: { type: Boolean, reflect: true },
    group: { type: String, reflect: true },
    id: { type: String, reflect: true },
  }

  connectedCallback() {
    super.connectedCallback()
    this.open = this.open ?? false
    this.id = this.id ?? nanoid()
    if (this.group && this.id) {
      window.MicroBus.on(`${this.group}-accordion-group:toggle`, (e) => {
        if (this.id != e.detail.id && this.open && e.detail.open) {
          this._toggle()
        }
      })
    }
  }

  firstUpdated() {
    this.querySelector('[slot="body"]').classList.add('loaded')
    if (this.open) {
      this._toggle(null, true)
    }
  }

  render() {
    return html`
      <slot name="header" @click=${this._toggle}></slot>
      <div class="body" aria-expanded=${this.open}>
        <slot name="body"></slot>
      </div>
    `
  }

  _toggle(e, forceState) {
    this.open = forceState ?? !this.open
    let body = this.shadowRoot.querySelector('.body')
    if (this.open) {
      this.ariaExpanded = 'true'
      body.style['max-height'] = body.scrollHeight + 'px'
    } else {
      this.ariaExpanded = 'false'
      body.style['max-height'] = ''
    }
    //emit event that to the accordion group with current accordion item state
    if (this.group && this.id) {
      window.MicroBus.emit(`${this.group}-accordion-group:toggle`, { open: this.open, id: this.id })
    }
  }
}
customElements.define('accordion-item', AccordionItem)
